import React from 'react';
import { Dialog } from './Dialog';
import { Button } from '../Button/Button';
import { Space } from 'antd';
import { 
  ExclamationCircleOutlined, 
  InfoCircleOutlined,
  CheckCircleOutlined,
  WarningOutlined 
} from '@ant-design/icons';
import PropTypes from 'prop-types';

const dialogTypes = {
  info: {
    icon: <InfoCircleOutlined style={{ color: '#1677ff' }} />,
    title: 'Information',
    okType: 'primary'
  },
  success: {
    icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    title: 'Success',
    okType: 'primary'
  },
  warning: {
    icon: <WarningOutlined style={{ color: '#faad14' }} />,
    title: 'Warning',
    okType: 'primary'
  },
  error: {
    icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
    title: 'Error',
    okType: 'primary'
  },
  confirm: {
    icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
    title: 'Confirm',
    okType: 'primary'
  }
};

export const CommonDialog = ({
  open,
  onClose,
  type = 'info',
  title,
  message,
  onOk,
  okText = 'OK',
  cancelText = 'Cancel',
  loading = false,
}) => {
  const dialogConfig = dialogTypes[type];
  
  const getActions = () => {
    if (type === 'confirm') {
      return (
        <>
          <Button onClick={onClose} disabled={loading}>
            {cancelText}
          </Button>
          <Button 
            onClick={onOk} 
            type={dialogConfig.okType}
            loading={loading}
          >
            {okText}
          </Button>
        </>
      );
    }
    
    return (
      <Button onClick={onClose} type={dialogConfig.okType}>
        {okText}
      </Button>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        <Space>
          {dialogConfig.icon}
          <span>{title || dialogConfig.title}</span>
        </Space>
      }
      actions={getActions()}
    >
      {message}
    </Dialog>
  );
};

CommonDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'confirm']),
  title: PropTypes.node,
  message: PropTypes.node.isRequired,
  onOk: PropTypes.func,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  loading: PropTypes.bool,
};

export default CommonDialog; 